import type { CurrencyISO } from '@/constants/currencies';

import type { CellData as RootCellData } from '../types';

import type { getCellTemplate } from './utils';

export const kind = 'ticker-cell' as const;

export interface TickerCellData
  extends RootCellData<typeof kind, string | null> {
  readonly currencyISO: CurrencyISO | null;
  readonly name: string | null;
  readonly uniqueSymbol: string | null;
  readonly status: 'idle' | 'pending' | 'success' | 'error';
  readonly error: string | null;
}

export type TickerCell = ReturnType<typeof getCellTemplate>;
